enum SizeEnum {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  XLarge = 'XLARGE',
}

export default SizeEnum;
